import Participant from './participant';

export default Participant;
